import { Grid, Typography } from "@material-ui/core";
import {
  RowDetailButtonDelete,
  RowDetailButtonEdit,
} from "../../../Common/RowDetailButtons";
import DetailCard, { DetailCardItem } from "../../../Common/DetailCard";
import ToolStrip from "../../../Common/ToolStrip";
import theme from "../../../themes/theme";
import { useVStore } from "../../stores/vStore";
import SmartGridItem from "../../../Common/SmartGridItem";
import { UserRights } from "../../models/progmaUserRights";
import { CellRowPanel } from "../../../Common/TableComponents";

export default function ArticleProjectRowDetail({ row }: any) {
  const {
    articlesStore: { articles, deleteArticle },
    articleFormStore: { openArticleForm },
    progmaUserStore: { progmaUserRights },
  } = useVStore();

  const id: number = row.id;

  const article = articles!.find((x) => x.id === id);

  if (!article)
    return <Typography color="error">Kan artikel niet vinden</Typography>;

  let detailCardItems: DetailCardItem[] = [
    { title: "Nummer", value: article.articleNumber },
    { title: "Type", value: article.type },
    { title: "Naam", value: article.name },
    { title: "Inactief", value: article.inactive, type: "boolean" },
  ];

  return (
    <CellRowPanel>
      <Grid
        container
        spacing={2}
        style={{
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <SmartGridItem>
          <DetailCard detailCardItems={detailCardItems} />
        </SmartGridItem>

        {progmaUserRights?.articlesUserRights === UserRights.Editing && (
          <SmartGridItem>
            <ToolStrip
              flexDirection="column"
              alignItems="start"
              spacing={0.5}
              fullwidth
            >
              <RowDetailButtonEdit onClick={() => openArticleForm(id)} />
              <RowDetailButtonDelete
                onDeleteConfirmed={() => deleteArticle(id)}
              />
            </ToolStrip>
          </SmartGridItem>
        )}
      </Grid>
    </CellRowPanel>
  );
}
